<template>
  <PillBrowserLink
    :text="$t('copy.homePage.mainLayout.usefulLinks.links.giving')"
    :url="`https://gens.app/give?prefilled_email=${email}`"
    firebase-event-name="useful-links-giving"
  />
</template>

<script>
import PillBrowserLink from './PillBrowserLink.vue';
import { mapState } from 'vuex';

export default {
  name: 'GivingSection',
  components: { PillBrowserLink },
  computed: {
    ...mapState('profile', ['email']),
  },
};
</script>
